import { CalendarIcon, ChevronRightIcon } from '@heroicons/react/outline'
import { DateTime } from 'luxon'
import { useRouter } from 'next/router'
import { flatten, propOr } from 'ramda'
import { useMemo } from 'react'

import useProgramRegistrations from '@/app/dashboard/events/stores/use-program-registrations'
import Link from '@/components/link'

import { getActiveRegistrations } from '../../utils/active-registrations'
import useProgram from '../stores/use-program'

const programSelector = propOr({}, 'program')
const registrationsSelector = propOr([], 'registrations')

const RegisteredSessions = () => {
  const {
    query: { handle },
  } = useRouter()
  const program = useProgram(programSelector)
  const registrations = useProgramRegistrations(registrationsSelector)

  const activeRegistrations = useMemo(
    () => getActiveRegistrations(program.id, registrations),
    [program.id, registrations],
  )

  const sessions = flatten(
    activeRegistrations.map((reg) =>
      reg.registrationOption.schedule.map((schedule) => ({
        ...schedule,
        program: reg.program,
        registrationOption: reg.registrationOption,
      })),
    ),
  )

  return !activeRegistrations?.length ? null : (
    <div className='my-4 py-4'>
      <p className='mb-4'>Registered Sessions</p>
      <ul className='space-y-2'>
        {sessions.map((session) => (
          <li key={session.id}>
            <Link
              href={`/program/${handle}/session/${session.id}`}
              className='block rounded-md bg-white'
              noUnderline
            >
              <div className='flex items-center px-4 py-4 sm:px-6'>
                <div className='min-w-0 flex-1 sm:flex sm:items-center sm:justify-between'>
                  <div className='truncate'>
                    <div className='flex text-sm'>
                      <p className='truncate font-medium text-theme-blue'>
                        {DateTime.fromISO(session.startTime).toFormat(
                          `dd MMM yyyy`,
                        )}
                      </p>
                      <p className='ml-1 flex-shrink-0 font-normal text-gray-500'>
                        - {session.registrationOption.title}
                      </p>
                    </div>
                    <div className='mt-2 flex'>
                      <div className='flex items-center text-sm text-gray-500'>
                        <CalendarIcon
                          className='mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400'
                          aria-hidden='true'
                        />
                        <p>
                          Starts on{' '}
                          <time dateTime={session.startTime}>
                            {DateTime.fromISO(session.startTime).toFormat(
                              `h:mm a`,
                            )}
                          </time>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='ml-5 flex-shrink-0'>
                  <ChevronRightIcon
                    className='h-5 w-5 text-gray-400'
                    aria-hidden='true'
                  />
                </div>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default RegisteredSessions
